import { useState } from "react";
import { Card } from "../components/ui";
import { supabase } from "../supabaseClient";
import { S, css } from "../theme";

function Settings({ user }) {
  const [portalLoading, setPortalLoading] = useState(false);
  const [portalError, setPortalError] = useState("");

  async function openCustomerPortal() {
    setPortalError("");
    setPortalLoading(true);
    try {
      const { data: sessionData } = await supabase.auth.getSession();
      const token = sessionData?.session?.access_token;
      const res = await fetch("/.netlify/functions/customer-portal", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
        body: JSON.stringify({ stripeCustomerId: user.stripe_customer_id, origin: window.location.origin }),
      });
      const data = await res.json();
      if (!res.ok) {
        setPortalError(data.error || "Could not open billing portal.");
        setPortalLoading(false);
        return;
      }
      window.location.href = data.url;
    } catch (err) {
      setPortalError("Could not open billing portal. Please try again.");
      setPortalLoading(false);
    }
  }

  return (
    <div style={{ padding: 40, maxWidth: 600 }}>
      <h2 style={{ ...css.fontDisplay, fontSize: "1.8rem", fontWeight: 500, color: S.ink, letterSpacing: "-0.02em", marginBottom: 8 }}>Settings</h2>
      <p style={{ color: S.muted, fontSize: "0.85rem", marginBottom: 32, fontFamily: "'Fraunces', serif", fontStyle: "italic" }}>Your account, in one place.</p>

      {/* Subscription / Founding Member card */}
      {user?.tier === "founding_member" && (
        <Card style={{ marginBottom: 24, background: "linear-gradient(135deg, #1e2520, #19211d)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
            <span style={{ background: S.accent2, color: "#fff", fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: "0.62rem", padding: "4px 11px", borderRadius: 100, letterSpacing: "0.1em", textTransform: "uppercase" }}>
              Founding Member
            </span>
            <span style={{ fontSize: "0.7rem", color: S.muted }}>🌿</span>
          </div>
          <p style={{ fontSize: "0.88rem", color: S.ink2, lineHeight: 1.65, marginBottom: 0, fontFamily: "'Fraunces', serif", fontStyle: "italic" }}>
            You were here first. Your account stays free, for as long as we exist.
          </p>
        </Card>
      )}

      {user?.tier === "pro" && (
        <Card style={{ marginBottom: 24 }}>
          <h3 style={{ ...css.fontDisplay, fontWeight: 500, fontSize: "1.05rem", color: S.ink, marginBottom: 8 }}>Subscription</h3>
          <div style={{ fontSize: "0.85rem", color: S.muted, marginBottom: 16, lineHeight: 1.7 }}>
            You're on <strong style={{ color: S.accent }}>Pro</strong>
            {user.subscription_status && <> · {user.subscription_status}</>}
            {user.subscription_current_period_end && (
              <> · renews {new Date(user.subscription_current_period_end).toLocaleDateString()}</>
            )}
          </div>
          <button onClick={openCustomerPortal} disabled={portalLoading} style={{ padding: "11px 20px", borderRadius: 100, border: "1.5px solid " + S.border, background: "transparent", color: S.ink, fontFamily: "'Inter', sans-serif", fontWeight: 500, fontSize: "0.85rem", cursor: portalLoading ? "wait" : "pointer" }}>
            {portalLoading ? "Opening…" : "Manage subscription"}
          </button>
          {portalError && <p style={{ color: S.accent2, fontSize: "0.82rem", marginTop: 10 }}>{portalError}</p>}
        </Card>
      )}

      <Card style={{ marginBottom: 24 }}>
        <h3 style={{ ...css.fontDisplay, fontWeight: 500, fontSize: "1.05rem", color: S.ink, marginBottom: 6 }}>AI Features</h3>
        <p style={{ fontSize: "0.82rem", color: S.muted, lineHeight: 1.7, marginBottom: 16 }}>
          AI Guidance chat and live FDA updates are powered by Claude and work automatically — no setup needed on your end.
        </p>
        <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: S.accentLight, borderRadius: 10 }}>
          <span style={{ fontSize: "0.9rem" }}>✓</span>
          <span style={{ fontSize: "0.82rem", color: S.accent, fontWeight: 600 }}>AI features active</span>
        </div>
      </Card>

      <Card>
        <h3 style={{ ...css.fontDisplay, fontWeight: 500, fontSize: "1.05rem", color: S.ink, marginBottom: 12 }}>Account</h3>
        <div style={{ fontSize: "0.85rem", color: S.muted, lineHeight: 2 }}>
          <div><strong style={{ color: S.ink }}>Name:</strong> {user.name}</div>
          <div><strong style={{ color: S.ink }}>Email:</strong> {user.email}</div>
          <div style={{ marginTop: 4, fontSize: "0.75rem" }}>Your data syncs securely across all your devices.</div>
        </div>
      </Card>
    </div>
  );
}


// ─── COMMUNITY ───────────────────────────────────────────────

export { Settings };
